var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 31,
    viewBox: "0 0 25 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.4997 0.0449219C9.37499 0.0484666 6.37928 1.29132 4.16977 3.50083C1.96027 5.71033 0.717412 8.70605 0.713867 11.8308C0.713867 21.9157 11.4283 29.5323 11.885 29.851C12.0651 29.9772 12.2797 30.0449 12.4997 30.0449C12.7197 30.0449 12.9343 29.9772 13.1144 29.851C13.5711 29.5323 24.2855 21.9157 24.2855 11.8308C24.282 8.70605 23.0391 5.71033 20.8296 3.50083C18.6201 1.29132 15.6244 0.0484666 12.4997 0.0449219ZM12.4997 7.545C13.3473 7.545 14.1759 7.79635 14.8807 8.26728C15.5855 8.7382 16.1348 9.40755 16.4592 10.1907C16.7836 10.9738 16.8685 11.8355 16.7031 12.6669C16.5377 13.4982 16.1296 14.2619 15.5302 14.8612C14.9308 15.4606 14.1672 15.8688 13.3358 16.0342C12.5045 16.1995 11.6427 16.1147 10.8596 15.7903C10.0765 15.4659 9.40715 14.9166 8.93622 14.2118C8.4653 13.507 8.21394 12.6784 8.21394 11.8308C8.21394 10.6941 8.66548 9.604 9.46921 8.80027C10.2729 7.99653 11.363 7.545 12.4997 7.545Z",
    fill: "#FFF9EE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationIcon);
export default __webpack_public_path__ + "static/media/location_icon.2ae86aa916f64c20f7aef6659b319e8d.svg";
export { ForwardRef as ReactComponent };